import AdminTimeTable from "../components/Admin/TimeTable/AdminTimeTable";

const  TimeTable = () => {
     return <AdminTimeTable/>
}

export default TimeTable;